import GameGradesTable from './GameGradesTable';

export default GameGradesTable;
